/* src/app/components/order-expired-page/order-expired-page.component.scss */
.page {
  padding: 20% 40%;
  font-family: "Maxis-Semibold";
  font-size: 16px;
  text-align: center;
}
/*# sourceMappingURL=order-expired-page.component.css.map */
